/* eslint array-callback-return: 0 */

import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';

/**
* @ngdoc service
* @name notifications.PaymentTypesNotifications
*
* @description
* This class is used to process notifications on payment_types enpoint.
*/
const PaymentTypesNotifications = {

    alertDisplayed: false,

    /**
     * @ngdoc function
     * @name notifications.PaymentTypesNotifications#isCardExpired
     * @methodOf notifications.PaymentTypesNotifications
     * @function
     *
     * @description
     * This function can be used to check is a payment method has been/ will be
     * expired within the notification time of days
     *
     * @param {object} payments An object with paymentsTypes
     * @param {number} notificationsTime a number of days
     */
    isCardExpired(payment, notificationsTime) {

        const now = moment();
        const formatedDate = payment.attributes.expiration_date.split('-');
        if (formatedDate.length > 1) {

            // create a new date at last day of month
            const paymentExpirationDate =
                moment(new Date(Number(formatedDate[0]), Number(formatedDate[1]), 0));
            return paymentExpirationDate.diff(now, 'days') <= notificationsTime;

        }
        return false;

    },

    /**
     * @ngdoc function
     * @name notifications.PaymentTypesNotifications#processCheckPayments
     * @methodOf notifications.PaymentTypesNotifications
     * @function
     *
     * @description
     * This function can be used to process the creation
     * of payments types and send notifications if any are expired
     *
     * @param {object} payments An object with paymentsTypes
     */

    processCheckPayments(payments) {

        let showExpiredAlert = false;

        payments.forEach((payment) => {

            // check if the expiration date has this format 2018-11-16T15:02:04+02:00
            if (!payment.attributes.expiration_date || payment.attributes.expiration_date.indexOf('-') === -1) {

                return;

            }
            // notify with 10days before
            const daysBeforeExpiration =
                CWCONFIG.features.paymentTypesDaysBeforeExpiration || 10;
            if (this.isCardExpired(payment, daysBeforeExpiration)) {

                showExpiredAlert = true;

            }

        });

        if (showExpiredAlert && this.alertDisplayed === false) {

            this.alertDisplayed = true;

            setTimeout(() => Alert.warning('cw.payment.expired_notification'), CWCONFIG.timeouts.expiredPaymentTypes);

        }

    },

};

export default PaymentTypesNotifications;



// WEBPACK FOOTER //
// ./scripts/common/notifications/-RFC.paymentTypesNotifications.js